import styled from '@xstyled/styled-components';
import React from 'react';
import { Flex } from '~/ui/flex/Flex';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { LAYOUT_TABLE } from '../itemIds';

const StyledTable = styled.table`
  width: 80%;
  min-width: 300px;
  border-spacing: 0px;
  border-collapse: collapse;
  > tbody > tr > td {
    border-bottom: 2px solid #c2bdcc;
    padding-top: 33px;
    padding-bottom: 33px;
  }
  > tbody > tr > th {
    border-bottom: 2px solid #c2bdcc;
    text-align: left;
  }
`;

export type LayoutTableDefinition = ItemDefinition<typeof LAYOUT_TABLE, void>;

export class LayoutTable extends Item<typeof LAYOUT_TABLE, void> {
  protected render({ children }: RenderProps<void>) {
    return (
      <Flex variant="center">
        <StyledTable>
          <tbody>{children}</tbody>
        </StyledTable>
      </Flex>
    );
  }
}

registry[LAYOUT_TABLE] = LayoutTable;
